/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./displayField.vue?vue&type=template&id=2ca46b16&scoped=true"
import script from "./displayField.vue?vue&type=script&lang=js"
export * from "./displayField.vue?vue&type=script&lang=js"
import style0 from "./displayField.vue?vue&type=style&index=0&id=2ca46b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca46b16",
  null
  
)

export default component.exports